import { render, staticRenderFns } from "./MilestoneComponent.vue?vue&type=template&id=100f96d6&"
import script from "./MilestoneComponent.vue?vue&type=script&lang=js&"
export * from "./MilestoneComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports